<template>
<div>
			<div class="d-flex align-items-center bg-white position-relative">
				<div class="mgl-24 left-button" v-if="isSearchOpen">
					<button class="mdc-icon-button" @click="closeSearch">
						<i class="material-icons t-headline6">close</i>
					</button>
				</div>
				<div v-if="isSearchOpen" class="d-flex flex-grow-1 pdl-20 pdr-60 mgl-60 mgr-100">
					<input 
						class="t-headline13 t-color-headlineBlack pda-10 flex-grow-1 fix-header-title d-flex align-items-center justify-content-center border-none search-input"
						:placeholder="$t('3917')"
						ref="searchInputRef"
						autofocus
						type="text"
						@keyup.enter="setSearchText"
						:value="searchText"
					/>
				</div>
				<div 
					v-else
					class="t-headline13 t-color-headlineBlack pda-14 flex-grow-1 fix-header-title d-flex align-items-center justify-content-center"
				>
					<div class="font-m ">{{title}}</div>
				</div>
				<div class="mgr-24 right-button" v-if="!isMicro">
					<button class="mdc-icon-button" @click="setSearchText('SEARCH_BTN')" v-if="isSearchOpen">
						<i class="material-icons t-headline6">search</i>
					</button>
					<button class="mdc-icon-button" @click="handleSearch" v-else>
						<i class="material-icons t-headline6">search</i>
					</button>
				</div>
			</div>
			<div class="divider"></div>
			<!-- subtabs -->
			<div class="subtabs ">
				<div id="examViewTab" class="mdc-tab-bar main-tabs" role="tablist">
					<div class="mdc-tab-scroller ">
						<div class="mdc-tab-scroller__scroll-area">
							<div class="mdc-tab-scroller__scroll-content justify-content-center">
								<button class="mdc-tab mdc-tab--active"  tabindex="0" @click="moveTab('LEARNING')">
									<span class="mdc-tab__content">
										<span class="mdc-tab__text-label font-m t-body2">{{$t('67')}}</span>
									</span>
									<span class="mdc-tab-indicator mdc-tab-indicator--active">
										<span
											class="mdc-tab-indicator__content mdc-tab-indicator__content--underline"></span>
									</span>
									<span class="mdc-tab__ripple"></span>
								</button>

								<button aria-selected="true"   class="mdc-tab" tabindex="0" @click="moveTab2('')">
									<span class="mdc-tab__content">
										<span class="mdc-tab__text-label font-m t-body2">{{$t('1282')}}</span>
									</span>
									<span class="mdc-tab-indicator">
										<span
											class="mdc-tab-indicator__content mdc-tab-indicator__content--underline"></span>
									</span>
									<span class="mdc-tab__ripple"></span>
								</button>

								<button aria-selected="true"  class="mdc-tab " tabindex="0" @click="moveTab1('COMPLETION')">
									<span class="mdc-tab__content">
										<span class="mdc-tab__text-label font-m t-body2">{{$t('68')}}</span>
									</span>
									<span class="mdc-tab-indicator ">
										<span
											class="mdc-tab-indicator__content mdc-tab-indicator__content--underline"></span>
									</span>
									<span class="mdc-tab__ripple"></span>
								</button>
								<!-- <button class="mdc-tab" role="tab">
									<span class="mdc-tab__content">
										<span class="mdc-tab__text-label font-m t-body2">학습 완료</span>
									</span>
									<span class="mdc-tab-indicator ">
										<span
											class="mdc-tab-indicator__content mdc-tab-indicator__content--underline"></span>
									</span>
									<span class="mdc-tab__ripple"></span>
								</button> -->
							</div>
						</div>
					</div>
				</div>

				<div class="divider divider-subtabs"></div>
			</div>
			</div>
</template>


<script>
/**
 * 나의 학습 목록 컴포넌트(my learning list tab Components)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import { MDCTabBar } from '@material/tab-bar';
import { mapActions, mapState } from 'vuex';

export default {
	props:['title'],

	data() {
		return {
			tabBar: null,
      isMicro: this.$route.path === '/micro'
		}
	},

	mounted() {
		this.tabBar = new MDCTabBar(document.querySelector('.mdc-tab-bar'))
		this.setTabActive()
	},

	computed: {
		...mapState({
			isSearchOpen: (state) => state.learn.isSearchOpen,
			searchText: (state) => state.learn.searchText,
		}),
	},

	methods: {
		...mapActions('learn', ["SET_IS_SEARCH_OPEN", "SET_SEARCH_TEXT"]),

		setTabActive() {
			let status = this.$route.query.status
			if (status === 'LEARNING') {
				this.tabBar.activateTab(0)
			} else if (status === 'COMPLETION') {
				this.tabBar.activateTab(2)
			} else if (status === 'WAITING') {
        		this.tabBar.activateTab(1)
      		} else {
				this.tabBar.activateTab(0)
			}
		},

		moveTab(type) {
			if(this.isMicro) {
				this.$router.push('/micro?status=LEARNING')
			} else {
				this.$router.push('/learn?status=LEARNING')
			}
		},

		moveTab1(type) {
			if(this.isMicro) {
				this.$router.push('/micro?status=COMPLETION')
			} else {
				this.$router.push('/learn?status=COMPLETION')
			}
		},

		moveTab2(type) {
			if(this.isMicro) {
				this.$router.push('/micro?status=WAITING')
			} else {
				this.$router.push('/learn?status=WAITING')
			}
		},

		handleSearch() {
			this.SET_IS_SEARCH_OPEN(true);
		},
		
		closeSearch() {
			this.SET_IS_SEARCH_OPEN(false);
		},

		setSearchText(e) {
			this.SET_SEARCH_TEXT(e === "SEARCH_BTN" ? this.$refs.searchInputRef.value : e.target.value)
		},
	}
}
</script>
<style scoped>
.search-input::placeholder {
	font-weight: 300 !important;
}
</style>
